/**
 * Accept Terms page — first-login gate.
 *
 * Renders after sign-in but before the SPA loads the main app. The user has
 * a session cookie already (they signed in via /auth/login), but the SPA's
 * session gate redirects here when tos_accepted_at is null.
 *
 * Submitting POSTs to Flask's /auth/accept-terms/ which stamps tos_accepted_at
 * and redirects to /matches. Not /accept-terms/: that is this page's own
 * path, served by nginx, which refuses a POST with 405.
 */
import { useState } from 'react'
import { signOut } from '../../lib/analytics'
import { API_BASE } from '../../lib/api'
import './auth.css'

export default function AcceptTerms() {
  const [agreed, setAgreed] = useState(false)

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">Priori</div>
        <h1 className="auth-title">Terms of Service</h1>
        <p className="auth-sub">
          Please review and accept our terms to continue.
        </p>

        <form action={`${API_BASE}/auth/accept-terms/`} method="POST">
          <p style={{ fontSize: 13, color: '#555', lineHeight: 1.6, marginBottom: 20 }}>
            By checking the box below you agree to our{' '}
            <a href="/terms-of-service" target="_blank" rel="noopener">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener">
              Privacy Policy
            </a>.
          </p>

          <label style={{ display: 'flex', alignItems: 'center', gap: 10,
                          fontSize: 14, marginBottom: 20, cursor: 'pointer' }}>
            <input type="checkbox" checked={agreed}
                   onChange={(e) => setAgreed(e.target.checked)}
                   style={{ width: 18, height: 18, accentColor: '#111' }} />
            I agree to the Terms of Service and Privacy Policy
          </label>

          <button className="auth-btn auth-btn--primary" type="submit"
                  disabled={!agreed}>
            Continue
          </button>
        </form>

        <div className="auth-links">
          <a href="#" onClick={(e) => { e.preventDefault(); signOut(`${API_BASE}/auth/logout`) }}>Sign out</a>
        </div>
      </div>
    </div>
  )
}
